import React from "react";
import { TablePagination } from "@mui/material";

const Pagination = ({
  count,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
}) => (
  <TablePagination
    rowsPerPageOptions={[5, 10, 25]}
    component="div"
    count={count}
    rowsPerPage={rowsPerPage}
    page={page}
    onPageChange={handleChangePage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    sx={{
      // Target the Select component inside TablePagination
      "& .MuiTablePagination-select": {
        paddingRight: "24px", // Add padding to prevent overlap with the arrow
      },
      "& .MuiTablePagination-selectIcon": {
        right: "5px", // Adjust the position of the arrow icon
      },
    }}
  />
);

export default Pagination;
